"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$otherLine = exports.ignoreTitleControl = exports.keepLeadingSpacesControl = void 0;
const factory_1 = __importDefault(require("../factory"));
const _indents_1 = __importDefault(require("./$indents"));
const line_1 = require("../../../node/cst/line");
const lexical_1 = require("./lexical");
const _sentencesArray_1 = __importDefault(require("./$sentencesArray"));
const inline_1 = require("../../../node/cst/inline");
const _xml_1 = __importDefault(require("./$xml"));
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const el_1 = require("../../../node/el");
const _squareAttr_1 = __importDefault(require("./$squareAttr"));
exports.keepLeadingSpacesControl = ":keep-leading-spaces:";
exports.ignoreTitleControl = ":ignore-title:";
/**
 * The parser rule for {@link OtherLine} that represents a line of other types. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/cst/rules/$otherLine.spec.ts) for examples.
 */
exports.$otherLine = factory_1.default
    .withName("otherLine")
    .sequence(s => s
    .and(() => _indents_1.default, "indentsStruct")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    // eslint-disable-next-line no-irregular-whitespace
    .and(r => r
    .sequence(s => s
    .and(r => r.regExp(/^:[^:\r\n]+:/), "value")
    .action(({ value, range }) => ({ value, range: range() }))), "control")
    .and(r => r
    .sequence(s => s
    .and(r => r
    .asSlice(r => r
    .choice(c => c
    .or(s => s
    .assert(({ control }) => control.value === exports.keepLeadingSpacesControl))
    .or(() => lexical_1.$_))), "value")
    .action(({ value, range }) => ({ value, range: range() }))), "trailingSpace")
    .action(({ control, trailingSpace }) => new inline_1.Control(control.value, control.range, trailingSpace.value, trailingSpace.range)))), "controls")
    .and(r => r
    .zeroOrOne(r => r
    .choice(c => c
    .orSequence(s => s
    // .andOmit(r => r.assert(({ controls }) => controls.some(c => c.control === ":xml:")))
    .and(() => _xml_1.default, "xml")
    .andOmit(r => r.nextIs(() => lexical_1.$_EOL))
    .action(({ range, xml }) => {
    const [start, end] = xml.value.range ?? range();
    const el = xml.value;
    const capturedEl = (std.isLine(el) || std.isQuoteStruct(el) || std.isArithFormula(el) || std.isRuby(el) || std.isSup(el) || std.isSub(el) || std.isControl(el))
        ? el
        : new el_1.EL("__CapturedXML", {}, [el], [start, end]);
    return {
        value: [
            new inline_1.Sentences("", [start, start], [], [(0, std_1.newStdEL)("Sentence", {}, [capturedEl], [start, end])])
        ],
        errors: xml.errors,
    };
}))
    .or(() => _sentencesArray_1.default)
    .orSequence(s => s
    .and(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .and(() => _squareAttr_1.default, "entry")
    .and(() => lexical_1.$_, "trailingSpace")
    .action(({ entry, trailingSpace, range }) => {
    const r = range();
    entry.value.trailingSpace = trailingSpace;
    if (entry.value.entryRange) {
        entry.value.trailingSpaceRange = [
            entry.value.entryRange[1],
            r[1],
        ];
    }
    return {
        value: entry.value,
        errors: entry.errors,
    };
}))), "attrEntries")
    .action(({ attrEntries, range }) => {
    const r = range();
    const errors = [...attrEntries.map(e => e.errors).flat()];
    return {
        value: [
            new inline_1.Sentences("", [r[0], r[0]], attrEntries.map(e => e.value).flat(), [])
        ],
        errors,
    };
})))), "columns")
    .and(() => lexical_1.$_EOL, "lineEndText")
    .action(({ range, indentsStruct, controls, columns, lineEndText }) => {
    const errors = [
        ...indentsStruct.errors,
        ...(columns?.errors ?? []),
    ];
    return {
        value: new line_1.OtherLine({
            range: range(),
            indentTexts: indentsStruct.value.indentTexts,
            controls,
            sentencesArray: columns?.value ?? [],
            lineEndText,
        }),
        errors,
    };
}));
exports.default = exports.$otherLine;
//# sourceMappingURL=$otherLine.js.map